export default "__VITE_ASSET__D24TapLS__"